import React, { useEffect, useState } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
  ChartDataLabels
);

function NetaddTrend({ chart_data, type = "monthly" }) {

  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });

  const [options, setOptions] = useState({});

  useEffect(() => {
    if (!chart_data || chart_data.length === 0) return;

    const labels =
    type === "quarterly"
      ? chart_data.map((item) => item.quarter_name)
      : chart_data.map((item) => item.month_name);

    const currentYear = chart_data.map((item) =>
      Number(item.current_year || 0) / 10000000
    );

    const lastYear = chart_data.map((item) =>
      Number(item.last_year || 0) / 10000000
    );

    const year3 = chart_data.map((item) =>
      Number(item.year_3 || 0) / 10000000
    );

    const year4 = chart_data.map((item) =>
      Number(item.year_4 || 0) / 10000000
    );

    const year5 = chart_data.map((item) =>
      Number(item.year_5 || 0) / 10000000
    );

    const currentFY =
        new Date().getMonth() + 1 >= 4
          ? new Date().getFullYear()
          : new Date().getFullYear() - 1;

      const fy1 = `${currentFY}-${currentFY + 1}`;
      const fy2 = `${currentFY - 1}-${currentFY}`;
      const fy3 = `${currentFY - 2}-${currentFY - 1}`;
      const fy4 = `${currentFY - 3}-${currentFY - 2}`;
      const fy5 = `${currentFY - 4}-${currentFY - 3}`;

    setData({
      labels,
      datasets: [
        {
          label: fy1,
          data: currentYear,
          borderWidth: 2,
          tension: 0.4,
          fill: false,
        },
        {
          label: fy2,
          data: lastYear,
          borderWidth: 2,
          tension: 0.4,
          fill: false,
        },
        {
          label: fy3,
          data: year3,
          borderWidth: 2,
          tension: 0.4,
          fill: false,
        },
        {
          label: fy4,
          data: year4,
          borderWidth: 2,
          tension: 0.4,
          fill: false,
        },
        {
          label: fy5,
          data: year5,
          borderWidth: 2,
          tension: 0.4,
          fill: false,
        },
      ],
    });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: {
          position: "top",
        },

        tooltip: {
          callbacks: {
            label: (context) =>
              `₹ ${Number(context.raw).toFixed(2)} Cr`,
          },
        },

        datalabels: {
          display: false,
        },
      },

      scales: {
        y: {
          ticks: {
            callback: (value) =>
              `₹ ${Number(value).toFixed(0)} Cr`,
          },
        },
      },
    });

  }, [chart_data]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "280px",
      }}
    >
      <Line data={data} options={options} />
    </div>
  );
}

export default NetaddTrend;